import { apiGet, apiPost } from '@forwardflow/services/Axios/configs'
import { ResponseSuccess } from '@forwardflow/types'
import { IAuth } from '@forwardflow/types/auth'

// Get access token after sso redirect
export default class AuthService {
   static apiGenerateAccessToken = async (token: string | null) => {
      const data = await apiGet<ResponseSuccess<IAuth>>({
         apiPath: `/auth/generate-access-token?token=${token}`,
         includeXOrg: false,
      })
      return data.data
   }
   static apiValidateEmail = async (token: string | null) => {
      const data = await apiPost<ResponseSuccess<IAuth>>({
         apiPath: `/auth/verify-email?token=${token}&redirectUrl=${window.location.origin}`,
         includeXOrg: false,
      })
      return data.data
   }
   static apiSignup = async (data: any, url: string | null) => {
      const response = await apiPost<ResponseSuccess<IAuth>>({
         apiPath: `/auth/sign-up?redirectUrl=${url}`,
         data,
         includeXOrg: false,
      })
      return response.data
   }
   static apiSignin = async (data: any) => {
      const response = await apiPost<ResponseSuccess<IAuth>>({
         apiPath: `/auth/login`,
         data,
         includeXOrg: false,
      })
      return response.data
   }
   static apiForgotPassword = async (url: string | null, email: string) => {
      const data = await apiPost<ResponseSuccess<any>>({
         apiPath: `/auth/forgot-password?redirectUrl=${url}`,
         data: {
            email: email,
         },
         includeXOrg: false,
      })
      return data.data
   }
   static apiResetPassword = async (
      token: string | null,
      password: string,
      redirectUrl: string
   ) => {
      const data = await apiPost<ResponseSuccess<IAuth>>({
         apiPath: `/auth/new-password?token=${token}&redirectUrl=${redirectUrl}`,
         data: {
            // token: token,
            newPassword: password,
         },
         includeXOrg: false,
      })
      return data.data
   }
   static apiResendVerificationMail = async (url: string | null) => {
      const data = await apiPost<ResponseSuccess<IAuth>>({
         apiPath: `/auth/resend-verification-email?redirectUrl=${url}`,
         includeXOrg: false,
      })
      return data.data
   }

   static apiRefreshToken = async () => {
      const data = await apiPost<ResponseSuccess<IAuth>>({
         apiPath: `/auth/refresh-token`,
         includeXOrg: false,
         withCredentials: true
      })
      return data.data
   }

   static apiLogout = async () => {
      const data = await apiPost<ResponseSuccess<null>>({
         apiPath: `/auth/logout`,
         includeXOrg: false,
      })
      return data.data
   }
}
